"use strict";

require("core-js/modules/es.array.reduce.js");

require("core-js/modules/es.array.flat-map.js");

require("core-js/modules/es.array.unscopables.flat-map.js");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var domain_1 = require("./domain");

var utils_1 = require("./utils");

function findFirstMatchingRule(node, rules) {
  return rules.map(function (rule) {
    var isMatch = utils_1.match(rule.regex, node);

    if (!isMatch) {
      return null;
    }

    return {
      match: isMatch,
      rule: rule
    };
  }).filter(function (result) {
    return result;
  }).reduce(utils_1.minBy(function (result) {
    return result ? result.match.index : Number.MAX_SAFE_INTEGER;
  }), null);
}

function findSurroundingNodes(node, matched) {
  var matchStart = matched.match.index;
  var matchEnd = matched.match.index + matched.match.fullmatch.length;
  var beforeMatch = node.slice(0, matchStart);
  var afterMatch = node.slice(matchEnd);
  return [[beforeMatch], [afterMatch]];
}

function parseMatch(matched, rules, recurse) {
  var matchedASTNode = matched.rule.parse(matched.match);

  if (recurse) {
    return nodeParser(matchedASTNode, rules.filter(function (rule) {
      return rule !== matched.rule;
    }), recurse);
  } else {
    return [matchedASTNode];
  }
}

function recurseAST(ast, rules, recurse) {
  return utils_1.flatMap(ast, function (child) {
    return nodeParser(child, rules, recurse);
  });
}

function nodeParser(node, rules, recurse) {
  if (typeof node === 'string') {
    var matched = findFirstMatchingRule(node, rules);

    if (!matched) {
      return [node];
    }

    var surroundingNodes = findSurroundingNodes(node, matched);

    var _a = surroundingNodes.map(function (surroundingNode) {
      return recurseAST(surroundingNode, rules, recurse);
    }),
        beforeAST = _a[0],
        afterAST = _a[1];

    var matchedAST = parseMatch(matched, rules, recurse);
    return __spreadArrays(beforeAST, matchedAST, afterAST);
  } else {
    return [{
      name: node.name,
      content: recurseAST(node.content, rules, recurse)
    }];
  }
}

function simplify(node) {
  if (typeof node === 'string') {
    return node.length === 0 ? [] : [node];
  } else {
    return [{
      name: node.name,
      content: utils_1.flatMap(node.content, simplify)
    }];
  }
}

function internalBuild(ast, rendererMap, node, key) {
  var _a;

  if (typeof node === 'string') {
    return node;
  }

  var renderer = rendererMap[node.name];

  if (renderer === undefined) {
    throw new Error('Unknown renderer: ' + node.name);
  }

  var element = renderer.react(node, ast);
  var children = ((_a = element.children) === null || _a === void 0 ? void 0 : _a.length) === 0 || node.content.length === 0 ? undefined : element.children || node.content.map(function (child, i) {
    return internalBuild(ast, rendererMap, child, i);
  });
  return react_1.createElement(element.type, __assign(__assign({}, element.props), {
    key: key
  }), children);
}

function convertRuleFormat(rules) {
  var blockRules = rules.filter(function (rule) {
    return rule.scope === domain_1.RuleScope.BLOCK;
  });
  var inlineRules = rules.filter(function (rule) {
    return rule.scope === domain_1.RuleScope.INLINE;
  });
  return {
    blockRules: blockRules,
    inlineRules: inlineRules
  };
}

function convertRuleToRendererMap(rule) {
  var _a;

  var map = (_a = {}, _a[rule.name] = rule, _a);
  Object.entries(rule.extraRenderers || {}).forEach(function (_a) {
    var name = _a[0],
        react = _a[1];
    map[name] = {
      name: name,
      react: react
    };
  });
  return map;
}

function parse(content, rules) {
  var trimmed = content.trim().replace(/\r/g, '');

  var _a = convertRuleFormat(rules),
      blockRules = _a.blockRules,
      inlineRules = _a.inlineRules;

  var initalAST = [trimmed];
  var afterBlockRules = utils_1.flatMap(initalAST, function (node) {
    return nodeParser(node, blockRules, false);
  });
  var afterInlineRules = utils_1.flatMap(afterBlockRules, function (node) {
    return nodeParser(node, inlineRules, true);
  });
  return utils_1.flatMap(afterInlineRules, simplify);
}

exports.parse = parse;

function build(ast, rules) {
  var ruleMap = rules.reduce(function (acc, rule) {
    return __assign(__assign({}, acc), convertRuleToRendererMap(rule));
  }, {});
  var nodes = ast.map(function (node, i) {
    return internalBuild(ast, ruleMap, node, i);
  });
  return react_1.createElement(react_1.Fragment, {}, nodes);
}

exports.build = build;